import moment from 'moment'

export const sorter = (a: any, b: any) => {
  const isNumber = `${+a}` === a
  return isNumber ? (a > b ? 1 : b < a ? -1 : 0) : moment(a).diff(moment(b))
}
